@if (market.longIds) {
    <button
        ds-button
        msThemedButton
        kind="tertiary"
        variant="outline"
        size="small"
        class="edit-pre-created-bab-button"
        [themeKind]="buttonThemeKind"
        (click)="clickHandler($event)">
        {{ sitecore.betBuilderEntainUI.messages?.EditPickButton }}
        @if (!epcotEnabled) {
            <vn-icon slot="end" name="theme-edit" size="10"></vn-icon>
        }
    </button>
}

<ng-template #header>
    <ms-betbuilder-overlay-header
        [eventName]="event.name"
        [eventStartDate]="event.startDate"
        [sportId]="event.sport.id"
        [leagueId]="event.league.id"
        [eventId]="event.id"
        [eventParticipants]="event.participants"
        [eventViewType]="event.viewType"></ms-betbuilder-overlay-header>
</ng-template>
